import { resolvePayment$, stepGuard } from '@kp/tiia-services';

import type { Route } from '@angular/router';

const extra = 'Sjednání cestovního pojištění - Komerční pojišťovna';

export const APP_ROUTES: Array<Route> = [
  {
    canMatch: [stepGuard(0)],
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    loadComponent: () => import('@kp/tiia-steps-0').then(m => m.Step0Component),
    path: '',
    pathMatch: 'full',
    title: extra,
  },
  {
    canActivate: [stepGuard(1)],
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    loadComponent: () => import('@kp/tiia-steps-1').then(m => m.Step1Component),
    path: 'vyber-pojisteni',
    title: `Výběr pojištění - ${extra}`,
  },
  {
    canActivate: [stepGuard(2)],
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    loadComponent: () => import('@kp/tiia-steps-2').then(m => m.Step2Component),
    path: 'osobni-udaje',
    title: `Osobní údaje - ${extra}`,
  },
  {
    canActivate: [stepGuard(3)],
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    loadComponent: () => import('@kp/tiia-steps-3').then(m => m.Step3Component),
    path: 'rekapitulace',
    title: `Rekapitulace - ${extra}`,
  },
  {
    canActivate: [stepGuard(4)],
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    loadComponent: () => import('@kp/tiia-steps-4').then(m => m.Step4Component),
    path: 'platba',
    title: `Platba - ${extra}`,
  },
  {
    canActivate: [stepGuard(5)],
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    loadComponent: () => import('@kp/tiia-steps-5').then(m => m.Step5Component),
    path: 'dokonceni',
    resolve: { payment: resolvePayment$ },
    title: `Dokončení - ${extra}`,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
